import { Fragment } from 'react';

interface PaginationProps {
	page: number;
	perPage: number;
	maxPages: number;
	pageChange: (page: string | undefined) => void;
}

const Pagination = (props: PaginationProps) => {
	let maxPagesArr = [...Array(props.maxPages).keys()];

	const getPageNumber = (number: number) => {
		if (number === props.page) {
			return (
				<span className="page-numbers current" key={number} data-number={number}>
					{number}
				</span>
			);
		}

		return (
			<span className="page-numbers" key={number} data-number={number} onClick={(event) => props.pageChange(event.currentTarget.dataset.number)}>
				{number}
			</span>
		);
	};

	return (
		<Fragment>
			<div className="dynamic-news__pagination">
				{maxPagesArr &&
					maxPagesArr.map((number) => {
						return getPageNumber(number + 1);
					})}
			</div>
		</Fragment>
	);
};

export default Pagination;
